export const COLOR_BY_STATUS = {
  POC_REJECT: '#888888',
  POC_ACCEPTED: '#1A7028',
  POC_EXPIRED: '#C3352B',
  POC_PICKED_UP: 'rgba(68,107,196,1)',
  CS_CANCELLEDOC: '#888888',
  DELIVERED: '#1A7028',
}

export const TYPE_BY_STATUS = {
  CS_CANCELLEDOC: 'error',
  DELIVERED: 'success',
  DM_ACCEPTED: 'warning',
  DM_CANCELLATION_REQUEST: 'error',
  DM_EN_ROUTE: 'info',
  DM_EXPIRED: 'error',
  DM_PICKED_UP: 'info',
  DM_REJECT: 'error',
  PENDING: 'progress',
  POC_ABANDONED: 'error',
  POC_ACCEPTED: 'warning',
  POC_EXPIRED: 'error',
  POC_PICKED_UP: 'info',
  POC_REJECT: 'error',
  SUSPECT: 'error',
  TRANSFERED: 'progress',
  USER_CANCELLED: 'error',
  WAITING_CONSUMER: 'progress',
  WAITING_COURIER: 'progress',
}

export const TEXT_COLOR_BY_STATUS = {
  CS_CANCELLEDOC: '#BA0B0B',
  DELIVERED: '#007800',
  DM_ACCEPTED: '#A65900',
  DM_CANCELLATION_REQUEST: '#BA0B0B',
  DM_EN_ROUTE: '#005AB5',
  DM_EXPIRED: '#BA0B0B',
  DM_PICKED_UP: '#005AB5',
  DM_REJECT: '#BA0B0B',
  POC_ABANDONED: '#BA0B0B',
  POC_ACCEPTED: '#A65900',
  POC_EXPIRED: '#BA0B0B',
  POC_PICKED_UP: '#005AB5',
  POC_REJECT: '#BA0B0B',
  SUSPECT: '#BA0B0B',
  USER_CANCELLED: '#BA0B0B',
}

export const SCHEDULED_ORDER_DELIVERY_TIME = '18'

export const NOTE_KEYWORDS = {
  ROOM_TEMPERATURE: '[PEDIDO EM TEMPERATURA AMBIENTE]',
  HEAVY_BAG: '[PEDIDO GRANDE COM ADICIONAL DE FRETE]',
}
